export const getInitialColors = colorFields =>
  colorFields.reduce((acc, field) => {
    acc[field.key] = field.defaultColor
    return acc
  }, {})

export const getInitialTextStyles = textFields =>
  textFields.reduce((acc, field) => {
    acc[field.key] = {
      fontFamily: field.defaultFont,
      fontSize: field.defaultSize,
      bold: field.defaultBold,
      italic: field.defaultItalic,
      color: field.defaultColor,
    }
    return acc
  }, {})
